import { SelectOption } from "components/atoms/Select";

const OptionService = {
  getOptions: (range: number, start: number = 0, before = "", after = "") => {
    let options: SelectOption[] = [];
    for (let i = start; i < range + start; i++) {
      options.push({ value: `${i}`, label: `${before}${i}${after}` });
    }

    return options;
  },
  getOptions_km: (
    range: number,
    start: number = 0,
    before = "",
    after = "",
    incl: any,
    km: any,
    opts?: { language?: string; daysLabel?: string }
  ) => {
    let options: SelectOption[] = [];
    let days = 24;
    let labelDays = 1;
    let max_km = 40;
    for (let i = start; i < range + start; i++) {
      if (i > 24) {
        days += 24;
        labelDays += 1;
        max_km += 480;

        options.push({
          value: `${days}`,
          label:
            opts?.language === "ar"
              ? `${before}${labelDays} ${opts?.daysLabel || "days"} (${incl} ${max_km} ${km})`
              : `${before}${labelDays}${" days"} (${incl} ${max_km} ${km})`,
        });
      } else {
        max_km += 40;
        let unit = after;
        let label: string;
        if (opts?.language === "ar") {
          // Arabic pluralization: 2 = ساعتين, 3-10 = ساعات, 11-99 = ساعة
          if (i === 2) {
            unit = "ساعتين";
            label = `${before}${i} ${unit} (${incl} ${max_km} ${km})`;
          } else if (i >= 3 && i <= 10) {
            unit = "ساعات";
            label = `${before}${i} ${unit} (${incl} ${max_km} ${km})`;
          } else if (i >= 11) {
            unit = "ساعة";
            label = `${before}${i} ${unit} (${incl} ${max_km} ${km})`;
          } else {
            // fallback for 0/1 if ever used
            unit = "ساعة";
            label = `${before}${i} ${unit} (${incl} ${max_km} ${km})`;
          }
        } else {
          label = `${before}${i} ${unit} (${incl} ${max_km} ${km})`;
        }
        options.push({
          value: `${i}`,
          label,
        });
      }
    }

    return options;
  },
  getClassOptions: () => {
    return [
      { value: "First", label: "First Class" },
      { value: "Business", label: "Business Class" },
      { value: "Van", label: "Van Class" },
    ];
  },
};
export default OptionService;
